import { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { getFirebaseServices } from "./firebase";

export function LoadingSponsors() {
  const [names, setNames] = useState<string[]>([]);
  useEffect(() => {
    let active = true;
    const services = getFirebaseServices();
    if (services) void httpsCallable<unknown, { names: string[] }>(services.functions, "getTerraBoaLoadingSponsors")({})
      .then(result => { if (active) setNames(result.data.names.filter(name => typeof name === "string")); }).catch(() => undefined);
    return () => { active = false; };
  }, []);
  return names.length ? <footer className="loading-sponsors" aria-label="Patrocinadores"><small>Com o apoio de</small><p>{names.join(" · ")}</p></footer> : null;
}
